// Tons âmbar do aviso "em atendimento em outra conexão" (chip, faixa, modal).
// `ink` mantém ≥ 4.5:1 sobre `surface` nos dois temas (texto de 11–13px).
export const crossConnectionTone = (theme) => {
  const dark = theme.palette.type === "dark";
  return {
    dark,
    surface: "rgba(245,158,11,0.10)",
    surfaceStrong: "rgba(245,158,11,0.18)",
    border: dark ? "rgba(251,191,36,0.28)" : "rgba(217,119,6,0.30)",
    ink: dark ? "#fbbf24" : "#92400e",
    inkStrong: dark ? "#fcd34d" : "#78350f",
    focus: dark ? "rgba(251,191,36,0.6)" : "rgba(217,119,6,0.55)",
  };
};

// Tom neutro (slate) do carimbo "último atendimento": informativo, nunca compete
// com o âmbar do atendimento aberto. `ink` mantém ≥ 4.5:1 sobre `surface`.
export const lastAttendanceTone = (theme) => {
  const dark = theme.palette.type === "dark";
  return {
    dark,
    surface: "rgba(100,116,139,0.10)",
    surfaceStrong: "rgba(100,116,139,0.18)",
    border: dark ? "rgba(148,163,184,0.28)" : "rgba(71,85,105,0.25)",
    ink: dark ? "#cbd5e1" : "#334155",
    inkStrong: dark ? "#e2e8f0" : "#1e293b",
    focus: dark ? "rgba(148,163,184,0.6)" : "rgba(71,85,105,0.55)",
  };
};
